export class ContainerWiseAbstractReq{
    year : number
    month : number

    constructor(year:number,month:number){
        this.year = year
        this.month = month
    }
}